// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3OmDU","notes":"Notes_notes__1tgOd"};